<template>
  <button v-if="view.meta" class="secondary" @click.stop="enter">
    With {{ view.meta.name }}
    <small class="team-progress">{{ progress }}</small>
  </button>
</template>

<script>
// "With <group>" on a Giant's card, with how far the group's room for this
// Giant has got (Sky, 2026-10-30: "I can't see team progress for giant
// crossword, only my own").
import { watchGroupDay } from '@/store/groups';
import { roomProgressLine } from '@/utils/myRooms';

export default {
  name: 'GiantGroupButton',
  props: {
    groupId: { type: String, required: true },
    giantId: { type: String, required: true },
  },
  data() {
    return { view: { meta: null, room: null, present: 0 }, now: Date.now() };
  },
  computed: {
    progress() { return this.view.room ? roomProgressLine(this.view.room, this.now) : 'not started'; },
  },
  mounted() {
    this.unbind = watchGroupDay(this.groupId, this.giantId, (view) => { this.view = view; });
    this.ticker = setInterval(() => { this.now = Date.now(); }, 1000);
  },
  beforeUnmount() {
    if (this.unbind) this.unbind();
    clearInterval(this.ticker);
  },
  methods: {
    enter() { this.$store.dispatch('enterGroup', { groupId: this.groupId, date: this.giantId }); },
  },
};
</script>

<style lang="scss" scoped>
.team-progress { display: block; font-size: 0.75rem; font-weight: 600; opacity: 0.8; font-variant-numeric: tabular-nums; }
</style>
